export const pcPageConfig = {
  "title": "Realtime Steam CCU",
  "titleCN": "实时Steam在线",
  "path": "/realtime/steamCCU",
  "defaultTab": "utc0",
  "subTitle": "Timezone (UTC{{timeZone}}) Datasource : Steam Platform",
  "subTitleCN": "时区 (UTC{{timeZone}}) 数据源 : Steam平台",
  "data": {"timeZone": '+0'},
  "tabList": [
    {
      "id": "utc0",
      "tabName": "UTC+0",
      "tabNameCN": "UTC+0",
      "isHaveNotification": true,
      "refresh": true,
      "refreshConfig": {
        "contentEn": 'Click to refresh or auto refresh every 10 minutes.',
        "contentCn": '单击可刷新或每10分钟自动刷新一次.'
      },
      "notificationPath": "/realtime/steamCCU/utc0",
      "path": "/realtime/steamCCU/utc0",
      "tabIcon": "",
      "logConfig": {
        "pageId": "205402",
        "pageName": "realtimeSteamCCU-UTC+0",
        "extInfo": "realtimeSteamCCU-UTC+0",
        "pagePath": "/realtime/steamCCU/utc0"
      },
      filters: [
        {
          name: 'RealtimeSteamCCUFilter',
          isOpenSticky: false,
          isHaveFilterSave: true,
          filterPath: '/realtime/steamCCU/utc0',
          componentList: [
            {
              name: 'RealtimeSteamCCUService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/realtime/steam/ccu',
                  isDark: true,
                  dataKey: 'steam_ccu',
                  refreshKey: 'realtime_user_revenue',
                  interval: 600000
                }
              },
              children: [
                {
                  name: 'RealtimeSteamCCUService',
                  className: '',
                  type: 'view',
                  style: {},
                  props: {
                    config: {
                      api: '/api/v1/dashboard/event_analysis/realtime/date_event_list',
                      isDark: true,
                      dataKey: 'date_event_list'
                    }
                  },
                  children: [
                    {
                      name: 'RealtimeRevenueContext',
                      props: {
                        config: {
                          title: 'Realtime Daily Steam CCU (10Mins)',
                          titleCn: '每日实时累计Steam在线（10分钟）',
                          formatTitle: 'realtime_revenue_realtime_revenue_title',
                          apiDataKey: 'steam_ccu',
                          className: "dbd-realtime-revenue-box",
                          noDataDisplay: true,
                          table: {
                            option: [
                              {
                                key: 'time',
                                align: 'left',
                                fixed: 'left',
                                width: 100,
                                title: 'Time',
                                titleCn: '时间',
                                formatTitle: 'realtime_by_country_table_time',
                                valueKey: 'time'
                              }, 
                              {
                                key: 'line_dot',
                                align: 'right',
                                fixed: '',
                                width: 100,
                                title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                                valueKey: 'lineDot',
                                format: '#,##0',
                                type: 'number'
                              }, 
                              {
                                key: 'line_dot_last',
                                align: 'right',
                                fixed: '',
                                width: 100,
                                title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                valueKey: 'lineDotLast',
                                format: '#,##0',
                                type: 'number'
                              }, 
                              {
                                key: 'line_dot_contrast',
                                align: 'right',
                                fixed: '',
                                width: 100,
                                title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day1',
                                titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日1',
                                valueKey: 'lineDotContrast',
                                changeDateTitle: 'Contrast Day1 {{contrastDaily|date|YYYY-MM-DD}}',
                                changeDateTitleCn: '对比日1 {{contrastDaily|date|YYYY-MM-DD}}',
                                format: '#,##0',
                                type: 'number'
                              },
                              {
                                key: 'line_dot_contrast2',
                                align: 'right',
                                fixed: '',
                                width: 100,
                                title: 'Release Date {{contrastDaily2|date|YYYY-MM-DD}} Contrast Day2',
                                titleCn: '发布日期 {{contrastDaily2|date|YYYY-MM-DD}} 对比日2',
                                valueKey: 'lineDotContrast2',
                                changeDateTitle: 'Contrast Day2 {{contrastDaily2|date|YYYY-MM-DD}}',
                                changeDateTitleCn: '对比日2 {{contrastDaily2|date|YYYY-MM-DD}}',
                                format: '#,##0',
                                type: 'number',
                                defaultDateCheck: true
                              }
                            ],
                            sort: true,
                            columns: ['time'],
                            defaultValue: [{ by: 'time', order: 'desc' }],
                            isRealTime: true,
                            height: 350
                          },
                          subTitle: [{
                            title: 'DoD',
                            titleCn: '日环比',
                            formatTitle: '',
                            valueKey: 'dod',
                            unit: 'percent',
                            bold: true
                          }, {
                            title: 'SDLW',
                            titleCn: '上周同期',
                            formatTitle: '',
                            valueKey: 'sdlw',
                            unit: 'percent',
                            bold: true
                          }],
                          event: {
                            show: true,
                            link: 'eventAnalysis/eventDetails',
                            dataKey: 'date_event_list',
                            timeType: 'Hour',
                            cssStyle: { top: '82%' }
                          },
                          chart: {
                            type: 'line',
                            series: [
                              {
                                valueKey: 'line_dot',
                                title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                              }, 
                              {
                                valueKey: 'line_dot_last',
                                title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                              }, 
                              {
                                valueKey: 'line_dot_contrast',
                                title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day1)',
                                titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日1)',
                                changeDateTitle: 'Contrast Day1 {{contrastDaily|date|YYYY-MM-DD}}',
                                changeDateTitleCn: '对比日1 {{contrastDaily|date|YYYY-MM-DD}}',
                                color: "#949BB3"
                              },
                              {
                                valueKey: 'line_dot_contrast2',
                                title: 'Release Date {{contrastDaily2|date|YYYY-MM-DD}} (Contrast Day2)',
                                titleCn: '发布日期 {{contrastDaily2|date|YYYY-MM-DD}} (对比日2)',
                                changeDateTitle: 'Contrast Day2 {{contrastDaily2|date|YYYY-MM-DD}}',
                                changeDateTitleCn: '对比日2 {{contrastDaily2|date|YYYY-MM-DD}}',
                                color: "#AD9EFF",
                                defaultDateCheck: true
                              }
                            ],
                            tooltip: {
                              title: 'Steam CCU',
                              titleCn: 'steam在线',
                              formatTitle: 'realtime_revenue'
                            },
                            height: 350
                          },
                          download: {
                            fileName: 'Realtime Daily Steam CCU (10Mins)',
                            fileNameCn: '每日实时累计Steam在线（10分钟）',
                            formatFileName: 'realtime_revenue_realtime_revenue_download',
                            default: '10',
                            title: 'Time',
                            titleCn: '时间粒度',
                            formatTitle: 'realtime_info_download_time',
                            type: [
                              {
                                title: 'By hour',
                                titleCn: '下载逐小时数据',
                                formatTitle: 'realtime_info_download_by_hour',
                                name: '60',
                                disable: 'l1h',
                                beforeDownload: 'hourDownload'
                              },
                              {
                                title: 'By 10 min',
                                titleCn: '下载每10 min数据',
                                formatTitle: 'realtime_info_download_by_10_min',
                                name: '10',
                                beforeDownload: ''
                              }
                            ],
                            sorting: false,
                            sort: 'desc'
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            },
          ]
        },
      ],
    },
    {
      "id": "utc8",
      "tabName": "UTC+8",
      "tabNameCN": "UTC+8",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/steamCCU/utc8",
      "path": "/realtime/steamCCU/utc8",
      "tabIcon": "",
      "logConfig": {
        "pageId": "205403",
        "pageName": "realtimeSteamCCU-UTC+8",
        "extInfo": "realtimeSteamCCU-UTC+8",
        "pagePath": "/realtime/steamCCU/utc8"
      },
      filters: [
        {
          name: 'RealtimeSteamCCUFilter',
          isOpenSticky: false,
          isHaveFilterSave: true,
          filterPath: '/realtime/steamCCU/utc0',
          componentList: [
            {
              name: 'RealtimeSteamCCUService',
              className: '',
              type: 'view',
              style: {},
              props: {
                config: {
                  api: '/api/v1/dashboard/pc/realtime/steam/ccu',
                  isDark: true,
                  dataKey: 'steam_ccu',
                  refreshKey: 'realtime_user_revenue',
                  interval: 600000,
                  timeZone: "+8",
                }
              },
              children: [
                {
                  name: 'RealtimeSteamCCUService',
                  className: '',
                  type: 'view',
                  style: {},
                  props: {
                    config: {
                      api: '/api/v1/dashboard/event_analysis/realtime/date_event_list',
                      isDark: true,
                      dataKey: 'date_event_list'
                    }
                  },
                  children: [
                    {
                      name: 'RealtimeRevenueContext',
                      props: {
                        config: {
                          title: 'Realtime Daily Steam CCU (10Mins)',
                          titleCn: '每日实时累计Steam在线（10分钟）',
                          formatTitle: 'realtime_revenue_realtime_revenue_title',
                          apiDataKey: 'steam_ccu',
                          className: "dbd-realtime-revenue-box",
                          noDataDisplay: true,
                          table: {
                            option: [
                              {
                                key: 'time',
                                align: 'left',
                                fixed: 'left',
                                width: 100,
                                title: 'Time',
                                titleCn: '时间',
                                formatTitle: 'realtime_by_country_table_time',
                                valueKey: 'time'
                              }, 
                              {
                                key: 'line_dot',
                                align: 'right',
                                fixed: '',
                                width: 100,
                                title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}',
                                valueKey: 'lineDot',
                                format: '#,##0',
                                type: 'number'
                              }, 
                              {
                                key: 'line_dot_last',
                                align: 'right',
                                fixed: '',
                                width: 100,
                                title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                valueKey: 'lineDotLast',
                                format: '#,##0',
                                type: 'number'
                              }, 
                              {
                                key: 'line_dot_contrast',
                                align: 'right',
                                fixed: '',
                                width: 100,
                                title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day1',
                                titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日1',
                                valueKey: 'lineDotContrast',
                                changeDateTitle: 'Contrast Day1 {{contrastDaily|date|YYYY-MM-DD}}',
                                changeDateTitleCn: '对比日1 {{contrastDaily|date|YYYY-MM-DD}}',
                                format: '#,##0',
                                type: 'number'
                              },
                              {
                                key: 'line_dot_contrast2',
                                align: 'right',
                                fixed: '',
                                width: 100,
                                title: 'Release Date {{contrastDaily2|date|YYYY-MM-DD}} Contrast Day2',
                                titleCn: '发布日期 {{contrastDaily2|date|YYYY-MM-DD}} 对比日2',
                                valueKey: 'lineDotContrast2',
                                changeDateTitle: 'Contrast Day2 {{contrastDaily2|date|YYYY-MM-DD}}',
                                changeDateTitleCn: '对比日2 {{contrastDaily2|date|YYYY-MM-DD}}',
                                format: '#,##0',
                                type: 'number',
                                defaultDateCheck: true
                              }
                            ],
                            sort: true,
                            columns: ['time'],
                            defaultValue: [{ by: 'time', order: 'desc' }],
                            isRealTime: true,
                            height: 350
                          },
                          subTitle: [{
                            title: 'DoD',
                            titleCn: '日环比',
                            formatTitle: '',
                            valueKey: 'dod',
                            unit: 'percent',
                            bold: true
                          }, {
                            title: 'SDLW',
                            titleCn: '上周同期',
                            formatTitle: '',
                            valueKey: 'sdlw',
                            unit: 'percent',
                            bold: true
                          }],
                          event: {
                            show: true,
                            link: 'eventAnalysis/eventDetails',
                            dataKey: 'date_event_list',
                            timeType: 'Hour',
                            cssStyle: { top: '82%' }
                          },
                          chart: {
                            type: 'line',
                            series: [
                              {
                                valueKey: 'line_dot',
                                title: 'Today {{singleDaily|date|YYYY-MM-DD}}',
                                titleCn: '今天 {{singleDaily|date|YYYY-MM-DD}}'
                              }, 
                              {
                                valueKey: 'line_dot_last',
                                title: 'Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}',
                                titleCn: '昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}',

                              }, 
                              {
                                valueKey: 'line_dot_contrast',
                                title: 'Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day1)',
                                titleCn: '上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日1)',
                                changeDateTitle: 'Contrast Day1 {{contrastDaily|date|YYYY-MM-DD}}',
                                changeDateTitleCn: '对比日1 {{contrastDaily|date|YYYY-MM-DD}}',
                                color: "#949BB3"
                              },
                              {
                                valueKey: 'line_dot_contrast2',
                                title: 'Release Date {{contrastDaily2|date|YYYY-MM-DD}} (Contrast Day2)',
                                titleCn: '发布日期 {{contrastDaily2|date|YYYY-MM-DD}} (对比日2)',
                                changeDateTitle: 'Contrast Day2 {{contrastDaily2|date|YYYY-MM-DD}}',
                                changeDateTitleCn: '对比日2 {{contrastDaily2|date|YYYY-MM-DD}}',
                                color: "#AD9EFF",
                                defaultDateCheck: true
                              }
                            ],
                            tooltip: {
                              title: 'Steam CCU',
                              titleCn: 'steam在线',
                              formatTitle: 'realtime_revenue'
                            },
                            height: 350
                          },
                          download: {
                            fileName: 'Realtime Daily Steam CCU (10Mins)',
                            fileNameCn: '每日实时累计Steam在线（10分钟）',
                            formatFileName: 'realtime_revenue_realtime_revenue_download',
                            default: '10',
                            title: 'Time',
                            titleCn: '时间粒度',
                            formatTitle: 'realtime_info_download_time',
                            type: [
                              {
                                title: 'By hour',
                                titleCn: '下载逐小时数据',
                                formatTitle: 'realtime_info_download_by_hour',
                                name: '60',
                                disable: 'l1h',
                                beforeDownload: 'hourDownload'
                              },
                              {
                                title: 'By 10 min',
                                titleCn: '下载每10 min数据',
                                formatTitle: 'realtime_info_download_by_10_min',
                                name: '10',
                                beforeDownload: ''
                              }
                            ],
                            sorting: false,
                            sort: 'desc'
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            },
          ]
        },
      ],
    },
  ]
};